import React from "react";
import { Box } from '@saladbob/sassafras'

import Image from "../../media/Image";
import { Upload } from "../../../types";

type Props = {
    image?: Upload,
    pdf?: Upload,
}


const SiteMap: React.FC<Props> = ({
    image,
    pdf,
}) => {
    if (!image) return null;
    return (
        <Box>
            <a href={pdf ? pdf.url : image.url} target="_blank">
                <Image image={image} size="hd" alt="image" />
            </a>
        </Box>
    )
}


export default SiteMap;
